import { useMutation } from 'react-query';

import { trackUntrackItems as mutationFn } from 'api/endPoints/trackUntrackItems';
import { ITrackUnTrackPayload } from 'api/mutations/exportCsvReport.mutation';

export const useMutationTrackUnTrackItems = () => {
    return useMutation<string, QueryError, ITrackUnTrackPayload>((params) => mutationFn(params));
};
